export default __webpack_public_path__ + "static/media/togetherCannabis.f14a96ce.jpg";